import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { XtramButton, XtramNotice } from '../../XtramModal/XtramModal';
import styles from '../ReportModalXtram.module.scss';

const describeIssue = (issue, t) => {
    if (issue.issueType === 'Duplicate') return `${t('Duplicate reference number')}: ${issue.actualReference}`;
    if (issue.issueType === 'Gap') return `${t('Missing reference number')}: ${issue.expectedReference}`;
    if (issue.issueType === 'Invalid') return `${t('Invalid reference format')}: '${issue.actualReference}'`;
    return issue.description;
};

const VatModalAlerts = ({
    t,
    direction,
    hasVatControlAccountEntries,
    code1AdjustmentAmount,
    referenceContinuityIssues,
    showReferenceAlert,
    setShowReferenceAlert,
    viewDocumentDetails,
    beautifyNumber,
}) => {
    const hasRefIssues = referenceContinuityIssues && !referenceContinuityIssues.isContinuous;
    if (!hasVatControlAccountEntries && !hasRefIssues) return null;

    const issues = referenceContinuityIssues?.issues ?? [];

    return (
        <div className={styles.alerts} dir={direction}>
            {hasVatControlAccountEntries && (
                <XtramNotice type="info">
                    <span>
                        {t('VatReportCode1Code2ExplanationBefore')}
                        <span className={styles.amountHighlight}>{beautifyNumber(code1AdjustmentAmount)}</span>
                        {t('VatReportCode1Code2ExplanationAfter')}
                    </span>
                </XtramNotice>
            )}

            {hasRefIssues && (showReferenceAlert ? (
                <XtramNotice type="warning">
                    <div className={styles.alertHeader}>
                        <span>{t('ReferenceContinuityIssues')} ({issues.length})</span>
                        <div className={styles.alertActions}>
                            {viewDocumentDetails && (
                                <XtramButton variant="secondary" small onClick={() => viewDocumentDetails('Incomes')}>
                                    {t('ViewIncomes')}
                                </XtramButton>
                            )}
                            <XtramButton variant="ghost" small onClick={() => setShowReferenceAlert(false)}>
                                {t('Hide')}
                            </XtramButton>
                        </div>
                    </div>
                    <ul className={styles.issueList}>
                        {issues.slice(0, 30).map((issue, index) => (
                            <li key={index}>{describeIssue(issue, t)}</li>
                        ))}
                        {issues.length > 30 && <li><em>+{issues.length - 30} {t('More')}</em></li>}
                    </ul>
                </XtramNotice>
            ) : (
                <XtramButton
                    variant="ghost"
                    small
                    className={styles.issuesChip}
                    onClick={() => setShowReferenceAlert(true)}
                >
                    <WarningAmberIcon sx={{ fontSize: 16, color: '#b45309' }} />
                    {`${issues.length} ${t('ReferenceContinuityIssues')}`}
                </XtramButton>
            ))}
        </div>
    );
};

export default VatModalAlerts;
